{
  "+ 1h": "+ 1č",
  "- 1h": "- 1č",
  "A dataset": "Skup podataka",
  "A post": "Objava",
  "A reuse": "Primer upotrebe",
  "A set of boolean parameters to toggle": "Set logičkih parametara",
  "A set of filters to apply": "Set filtera",
  "A topic": "Tema",
  "A user": "Korisnik",
  "API Key": "API klјuč",
  "About": "Osnovni podaci",
  "Accept": "Prihvati",
  "Accepted": "Prihvaćeno",
  "Acronym": "Akronim",
  "Active": "Aktivno",
  "Add": "Dodaj",
  "Add a comment": "Dodaj komentar",
  "Add a filter": "Dodaj filter",
  "Add a resource": "Dodajte resurs",
  "Add some related datasets": "Dodajte neke povezane skupove podataka",
  "Add some related reuses": "Dodajte neke povezane primere upotrebe",
  "Add your first resources": "Dodaj svoj prvi resurs",
  "All your resources looks to be directly available. That is great!": "Izgleda da su svi vaši resursi direktno dostupni. To je sjajno!",
  "An error occured": "Došlo je do greške",
  "An error occured while submitting your comment": "Došlo je do greške prilikom prosleđivanja vašeg komentara",
  "An error {status} occured": "Desila se greška {status}",
  "An harvester": "Harvester",
  "An organization": "Organizacija",
  "An unkown error occured": "Došlo je do interne greške",
  "Apply": "Primeni",
  "Archived": "Arhivirano",
  "Are you sure ?": "Da li ste sigurni?",
  "Are you sure you want to delete this comment?": "Sigurni ste da želite da obrišete ovaj komentar?",
  "Are you sure?": "Da li ste sigurni?",
  "As administrator you can choose any organization to publish": "Kao administrator, možete odabrati bilo koju organizaciju za objavlјivanje",
  "Attention": "Pažnja",
  "Automatic archiving": "Automatsko arhiviranje",
  "Availability": "Dostupnost",
  "Availability of your datasets": "Dostupnost skupova podataka",
  "Backend": "Pozadinska komponenta",
  "Badges": "Bedževi",
  "Between": "Između",
  "Bold": "Podeblјano",
  "Both dates are required": "Oba datuma su obavezna",
  "Cancel": "Otkaži",
  "Center the full picture": "Centrirajte celu sliku",
  "Certified public service": "Sertifikovani javni servis",
  "Change password": "Promenite lozinku",
  "Changes saved": "Izmene sačuvane",
  "Checksum": "Kontrolni zbir",
  "Choose under which identity you want to publish": "Izaberite pod kojim identitetom želite da objavite",
  "Choose who is harvesting": "Izaberite ko preuzima",
  "Choose who is publishing": "Izaberite ko objavlјuje",
  "Clear": "Obriši",
  "Click the button to copy the whole code within your clipboard": "Kopiraj u memoriju",
  "Close": "Zatvori",
  "Closed on": "Zatvoreno",
  "Comment": "Komentar",
  "Comment and close discussion": "Komentarišite i zatvorite diskusiju",
  "Comment the discussion": "Komentarišite diskusiju",
  "Communicate about your publication": "Komunikacija o publikaciji",
  "Community resources": "Resursi zajednice",
  "Configure your harvester": "Konfigurišite harvester",
  "Confirm": "Potvrdite",
  "Confirm deletion": "Potvrdite brisanje",
  "Confirm refusal": "Potvrdite odbijanje",
  "Confirm restore": "Poništi brisanje",
  "Content": "Sadržaj",
  "Copy-paste this code within your own HTML at the place you want the current dataset to appear:": "Kopirajte i nalepite ovaj kôd u svoj HTML, tamo gde želite da se pojavi trenutni skup podataka:",
  "Created at": "Napravlјeno u",
  "Created on": "Napravlјeno:",
  "Creation": "Kreiranje",
  "Dashboard": "Kontrolna tabla",
  "Data": "Podaci",
  "Daily": "Dnevno",
  "Data update": "Ažuriranje podataka",
  "Dataset": "Skup podataka",
  "Datasets": "Skupovi podataka",
  "Datasets-total": "setova ukupno",
  "Datasets (only yours)": "Skupovi podataka (samo vaši)",
  "Datasets as CSV": "Skupovi podataka kao CSV",
  "Datasets resources as CSV": "Resursi skupova podataka kao CSV",
  "Date": "Datum",
  "Date should be after start date": "Datum bi trebalo da bude posle datuma početka",
  "Delete": "Izbriši",
  "Delete comment": "Izbriši komentar",
  "Delete profile": "Izbriši profil",
  "Deleted": "Izbrisano",
  "Describe your community resource": "Opišite svoj resurs zajednice",
  "Describe your dataset": "Opišite svoj skup podataka",
  "Describe your organization": "Opišite svoju organizaciju",
  "Describe your reuse": "Opišite primer upotrebe",
  "Description": "Opis",
  "Details": "Detalјi",
  "Discussing with the community about your datasets is key to involve developers and hackers in your open process. The feedback from reusers of your data is unvaluable and should be answered rather quickly.": "Diskusija sa zajednicom o skupovima podataka klјučna je za uvođenje programera u vaš otvoreni proces. Povratne informacije od korisnika podataka neizmerno su važne i trebalo bi što pre odgovoriti na njih.",
  "Discussion": "Diskusija",
  "Discussion has been closed": "Diskusija je zatvorena",
  "Discussions": "Diskusije",
  "Discussions about your data (including your organizations)": "Razgovori o podacima (uklјučujući i vašu organizaciju)",
  "Do you confirm the transfer of": "Da li potvrđujete prenos",
  "Done": "Gotovo",
  "Done with errors": "Gotovo sa greškama",
  "Downloads": "Preuzimanja",
  "Drag a file here": "Prevucite datoteku ovde",
  "Drag a picture here": "Prevucite sliku ovde",
  "Drop resource": "Otpustite resurs",
  "Due to security reasons, the creation of new content is currently disabled.": "Kreiranje novog sadržaja je trenutno onemogućeno usled sigurosnih razloga.",
  "Edit": "Izmeni",
  "Edit dataset \"{title}\"": "Izmeni set podataka \"{title}\"",
  "Edit harvest source \"{name}\"": "Ažuriraj prikuplјač \"{name}\"",
  "Edit organization \"{name}\"": "Izmeni organizaciju \"{name}\"",
  "Edit post \"{name}\"": "Izmeni post \"{name}\"",
  "Edit profile": "Izmeni profil",
  "Edit reuse \"{title}\"": "Izmeni primer upotrebe \"{title}\"",
  "Edit the profile": "Izmeni profil",
  "Edit this dataset": "Izmeni podatke",
  "Edit this organization": "Izmeni Organizaciju",
  "Edit this reuse": "Izmeni ovo ponovno korišćenje",
  "Edit this user": "Izmeni ovo ponovno korišćenje",
  "Edit topic \"{name}\"": "Izmeni temu \"{name}\"",
  "Edit user": "Izmeni korisnika",
  "Editorial": "Uredništvo",
  "End": "Kraj",
  "End date should be after start date": "Datum završetka bi trebalo da bude posle datuma početka",
  "Ended at": "Završava se u",
  "Ensure your organization does not exists": "Uverite se da vaša organizacija ne postoji",
  "Errors": "Greške",
  "Exclude": "Isklјuči",
  "Expected update": "Očekivano ažuriranje",
  "Explain why you request this transfer": "Objasnite zašto tražite ovaj prenos",
  "Explain your response": "Objasnite svoj odgovor",
  "Explain your validation": "Objasnite validaciju",
  "Failed": "Nije uspelo",
  "Feature this content": "Istakni ovaj sadržaj",
  "Featured": "Istaknuto",
  "Featured datasets": "Odabrani skupovi podataka",
  "Featured reuses": "Istaknute upotrebe",
  "Features": "Mogućnosti",
  "Filters": "Filteri",
  "Find or create your organization": "Pronađite ili napravite svoju organizaciju",
  "Find your dataset": "Pronađite svoj skup podataka",
  "Find your reuse": "Pronađite primer upotrebe",
  "Finish": "Završi",
  "First name": "Ime",
  "First page": "Prva stranica",
  "Follow": "Prati",
  "Follower": "Pratilac",
  "Followers": "Pratioci",
  "Followers (only yours)": "Pratioci (samo vaši)",
  "Format": "Format",
  "Frequency": "Frekvencija",
  "Generate an API KEY": "Generisanje API klјuča",
  "Harvest as": "Preuzmi kao",
  "Harvest source validation": "Validacija izvora harvestera",
  "Harvesters": "Harvesteri",
  "Heading": "Naslov",
  "Headline": "Naslov",
  "Hits": "Pogoci",
  "I'll be informed about its activity": "Dobijaću obaveštenja o ovoj aktivnosti",
  "Image": "Slika",
  "Image is not tall enough.": "Slika nije dovolјno visoka.",
  "Image is not wide enough.": "Slika nije dovolјno široka.",
  "Image is too tall.": "Slika je previsoka.",
  "Image is too wide.": "Slika je previše široka.",
  "Include": "Uklјuči",
  "Initialized": "Pokrenuto",
  "Initializing": "Inicijalizacija",
  "Insert Hyperlink": "Umetnite hipervezu",
  "Insert Image Hyperlink": "Umetnite hipervezu slike",
  "Invalid API request:": "Neispravan API zahtev:",
  "It gives you an overview of what will be useful for contributors to find and reuse your data.": "To vam daje pregled toga šta će biti korisno za saradnike kako bi pronašli i upotrebili vaše podatke.",
  "It means that this source will be harvested regulary.": "To znači da će se podaci iz ovog izvora redovno preuzimati.",
  "It will not be possible to recover this profile once deleted.": "Podaci će biti trajno obrisani.",
  "It will not be possible to recover your profile once deleted.": "Podaci će biti trajno obrisani.",
  "Italic": "Kurziv",
  "Items": "Stavke",
  "Jobs": "Zadaci",
  "Last name": "Prezime",
  "Last page": "Poslednja stranica",
  "Last run": "Poslednje pokretanje",
  "Last update": "Poslednje ažuriranje",
  "License": "Licenca",
  "List": "Lista",
  "Loading": "Učitavanje",
  "Location": "Lokacija",
  "Logo": "Logotip",
  "Maybe you should find yours or create your own.": "Pronađi ili napravi svoju.",
  "Me": "Ja",
  "Member added": "Član je dodat",
  "Member deleted": "Član je izbrisan",
  "Member role updated": "Uloga člana je ažurirana",
  "Member since": "Član od",
  "Members": "Članovi",
  "Metadata update": "Ažuriranje metapodataka",
  "Mime Type": "MIME tip",
  "Modification": "Modifikacija",
  "Modified on": "Izmenjeno:",
  "More infos": "Više informacija",
  "Name": "Ime",
  "Need an update since {days} days.": "Potrebno mi je ažuriranje od pre {days} dan(a).",
  "New": "Novo",
  "New Post": "Nova objava",
  "New community resource": "Novi resurs zajednice",
  "New dataset": "Novi skup podataka",
  "New harvester": "Novi harvester",
  "New organization": "Nova organizacija",
  "New reuse": "Novi primer upotrebe",
  "New topic": "Nova tema",
  "Next": "Dalјe",
  "Next page": "Sledeća stranica",
  "No badge available": "Nema dostupnih bedževa",
  "No community resources": "Nema resursa zajednice",
  "No data": "Nema podataka",
  "No dataset": "Ne postoji nijedan skup podataka",
  "No discussion": "Nema diskusije",
  "No discussion yet? Try to involve users via social networks and/or by email.": "Još uvek nema diskusije? Pokušajte da uklјučite korisnike putem društvenih mreža i/ili putem e-pošte.",
  "No files to upload.": "Nema datoteka za otpremanje.",
  "No follower": "Nema pratilaca",
  "No harvester": "Nema harvestera",
  "No item found": "Nije pronađena nijedna stavka",
  "No job": "Nema zadatka",
  "No job yet": "Još nema nijednog zadatka",
  "No members": "Nema članova",
  "No membership requests": "Nema zahteva za članstvom",
  "No organization": "Nema nijedne organizacije",
  "No organization found. You can go to the next step to create your own one.": "Nije pronađena nijedna organizacija. Možete preći na sledeći korak da biste napravili vlastitu.",
  "No post": "Nema objava",
  "No related datasets": "Nema povezanih skupova podataka",
  "No related reuses": "Nema povezanih primera upotrebe",
  "No resources": "Nema resursa",
  "No result found": "Nema rezultata",
  "No reuse": "Nema nijednog primera upotrebe",
  "No topic": "Nema teme",
  "No user": "Nema korisnika",
  "No user found.": "Nije pronađen nijedan korisnik.",
  "Not scheduled": "Nije zakazano",
  "Notifications": "Obaveštenja",
  "Now": "Sada",
  "Number of archived items": "Broj arhiviranih stavki",
  "Number of datasets used": "Broj korišćenih skupova podataka",
  "Number of failed items": "Broj neuspešnih stavki",
  "Number of skipped items": "Broj preskočenih stavki",
  "Number of succeed items": "Broj uspešnih stavki",
  "Open data": "Otvoreni podaci",
  "Open formats": "Otvoreni formati",
  "Operation not permitted": "Operacija nije dozvolјena",
  "Organization": "Organizacija",
  "Organizations": "Organizacije",
  "Owner": "Vlasnik",
  "Pending": "Na čekanju",
  "Pending harvester validation for {name}": "Potvrda harvestera na čekanju za {name}",
  "Pending membership request": "Zahtev za članstvo na čekanju",
  "Pending transfer request": "Zahtev za prenos na čekanju",
  "Pick the active badges": "Izaberite aktivne bedževe",
  "Post": "Objava",
  "Post deleted": "Objava je obrisana",
  "Post published": "Objavlјeno",
  "Post unpublished": "Objava je opozvana",
  "Posts": "Vesti",
  "Preview": "Pregled",
  "Previous": "Prethodno",
  "Previous page": "Prethodna stranica",
  "Private": "Privatno",
  "Processing": "Obrada",
  "Profile": "Profil",
  "Proposing up-to-date and incremental data makes it possible for reusers to establish datavisualisations on the long term.": "Predlaganje ažurnih i inkrementalnih podataka omogućava korisnicima da uspostave vizuelizaciju podataka u dužem periodu.",
  "Public": "Javno",
  "Public profile": "Javni profil",
  "Publication": "Objavlјeno",
  "Publication date": "Datum objavlјivanja",
  "Publish": "Objavi",
  "Publish a new dataset": "Objavite novi skup podataka",
  "Publish a new reuse": "Objavite novi primer upotrebe",
  "Publish as": "Objavlјeno kao",
  "Publish as an organization": "Objavi kao organizacija",
  "Publish by": "Objavio:",
  "Publish in your own name": "Objavi kao lično svoje",
  "Publish some content": "Objavite neki sadržaj",
  "Published on": "Objavlјeno:",
  "Published on {date}": "Objavlјeno: {date}",
  "Quality": "Kvalitet",
  "Read the documentation to insert more than one dataset": "Pročitajte dokumentaciju da biste umetnuli više od jednog skupa podataka",
  "Reason": "Razlog",
  "Refuse": "Odbij",
  "Refused": "Odbijeno",
  "Regenerate": "Regeneracija",
  "Reject": "Odbaci",
  "Remote ID": "Dalјinski ID",
  "Remove": "Ukloni",
  "Reorder": "Preuredi",
  "Replace the file": "Zameni fajl",
  "Resize your thumbnail": "Promena veličine sličice",
  "Resources": "Resursi",
  "Resources count": "Broj resursa",
  "Response sent": "Odgovor je poslat",
  "Restore": "Povrati",
  "Retry failed - you have reached your file limit.": "Ponovni pokušaj nije uspeo – dostigli ste ograničenje broja datoteka.",
  "Reuse": "Primer upotrebe",
  "Reuses": "Primeri upotrebe",
  "Reuses about your data (including your organizations)": "Primeri upotrebe vaših podataka (uklјučujući i vaše organizacije)",
  "Role": "Uloga",
  "Role \"{role}\" is required": "\"{role}\" rola neophodna ",
  "Roles": "Uloge",
  "Save": "Sačuvaj",
  "Save and continue": "Sačuvaj i nastavi",
  "Schedule": "Raspored",
  "Scheduling": "Zakazivanje",
  "Schema": "Šema",
  "Score:": "Ocena:",
  "Search": "Pretraga",
  "Search an user": "Pretraga korisnika",
  "Search in your data: {q}": "Pretražite u vašim podacima: {q}",
  "See in the administration": "Pogledajte u administraciji",
  "See on the site": "Pogledajte na sajtu",
  "Select a file from your computer": "Izaberite datoteku sa računara",
  "Semidaily": "Dva puta dnevno",
  "Share": "Podeli",
  "Sign out": "Odjavite se",
  "Since": "Od",
  "Site": "Sajt",
  "Size": "Veličina",
  "Skipped": "Preskočeno",
  "Some of your resources may have broken links or temporary unavailability. Try to fix it as fast as you can (see the list below).": "Neki od vaših resursa možda imaju raskinute veze ili privremeno nisu dostupni. Pokušajte da to rešite što pre (pogledajte listu u nastavku).",
  "Spatial coverage": "Prostorna pokrivenost",
  "Spatial granularity": "Prostorna granularnost",
  "Stars": "Zvezdice",
  "Start": "Početak",
  "Start a discussion": "Započni diskusiju",
  "Start a new discussion": "Započni novu diskusiju",
  "Start typing to find your organization.": "Počnite da kucate da biste pronašli svoju organizaciju.",
  "Start typing to find your user.": "Počnite da kucate da biste pronašli korisnika.",
  "Started": "Započeto",
  "Started at": "Započeto u",
  "Starting a new discussion thread": "Započni diskusiju u novoj niti",
  "Status": "Status",
  "Submit your comment": "Objavi svoj komentar",
  "Summary": "Rezime",
  "System": "Sistem",
  "Tags": "Oznake",
  "Tags helps your reusers to find your resources, that is very important to make your dataset popular.": "Oznake pomažu korisnicima da pronađu vaše resurse, što je veoma važno da bi vaš skup podataka postao popularan.",
  "Temporal coverage": "Vremenska pokrivenost",
  "Territorial coverage": "Teritorijalna pokrivenost",
  "Territorial coverage granularity": "Granularnost teritorijalne pokrivenosti",
  "Territories": "Teritorije",
  "That is great!": "To je sjajno!",
  "The aim of that box is to help you improve the quality of the (meta)data associated to your dataset.": "Cilј ovog polјa jeste da vam pomogne da unapredite kvalitet (meta)podataka koji su povezani sa vašim skupom podataka.",
  "The availability of your distant resources (if any) is crucial for reusers. They trust you for the reliability of these data both in terms of reachability and ease of access.": "Dostupnost udalјenih resursa (ako postoje) od klјučnog je značaja za one koji koriste vaše podatke. Oni imaju poverenja u pouzdanost tih podataka, kako u smislu dostupnosti tako i kad je reč o jednostavnosti pristupa.",
  "The error identifier is {id}": "Identifikator greške je {id}",
  "The files are being uploaded, if you leave now the upload will be canceled.": "Datoteke se otpremaju. Ako sada prekinete proces, otpremanje će biti otkazano.",
  "The harvester has been updated.": "Harvester ažuriran.",
  "The identity of this public service is certified by %(certifier)s": "Identitet ovog javnog servisa je sertifikovan od %(certifier)s",
  "The open data community enjoy using files in open formats that can be manipulated easily through open software and tools. Make sure you publish your data at least in formats different from XLS, DOC and PDF.": "Zajednica korisnika otvorenih podataka koristi datoteke u otvorenim formatima kojima se može lako manipulisati kroz otvoreni softver i alatke. Uverite se da ste podatke objavili barem u formatima koji nisu HLS, DOC i PDF.",
  "The recipient need to accept the transfer in order to complete it.": "Primalac mora da prihvati prenos kako bi ga dovršio.",
  "The response has been sent to the requester.": "Odgovor je poslat podnosiocu zahteva.",
  "The user {fullname} has been successfully deleted": "Korisnik {fullname} je uspešno obrisan",
  "This harvest source has not been validated": "Ovaj izvor preuzimanja nije potvrđen",
  "This is a cron expressions. See {url} for more details.": "Vidi {url} za više detalјa.",
  "This item has been deleted": "Ova stavka je obrisana",
  "This key is needed if you want to use the API.": "Ovaj klјuč je neophodan ako želite da koristite API.",
  "This resource is hosted on an external server": "Ovaj resurs se nalazi na eksternom serveru",
  "This resource is hosted on our servers": "Ovaj resurs se nalazi na našim serverima",
  "This widget allows you to generate or regenerate your API Key.": "Ovaj vidžet vam omogućava da generišete ili regenerišete API klјuč.",
  "Title": "Naslov",
  "Today": "Danas",
  "Too many items ({netItems}) would be uploaded. Item limit is {itemLimit}.": "Bilo bi otpremlјeno previše stavki ({netItems}). Maksimalni broj stavki je {itemLimit}.",
  "Topic": "Tema",
  "Topic deleted": "Tema je obrisana",
  "Topics": "Teme",
  "Traffic": "Saobraćaj",
  "Transfer": "Prenos",
  "Transfer request": "Zahtev za prenos",
  "Transfer requested": "Zatražen je prenos",
  "Transfer to": "Prenos u",
  "Try to be as descriptive as you can for your resources (how you use it yourself, which edge cases you solved, what data is missing and so on).": "Pokušajte da date što bolјi opis resursa (kako ih vi koristite, koje granične slučajeve ste rešili, koji podaci nedostaju i tako dalјe).",
  "Type": "Tip",
  "Type an user name": "Otkucajte korisničko ime",
  "Type your comment": "Otkucajte komentar",
  "URL": "URL",
  "URL/Link": "URL/veza",
  "Unfollow": "Otprati",
  "Unique visitors": "Jedinstveni posetioci",
  "Unknown error while communicating with the server": "Nepoznata greška u komunikaciji sa serverom",
  "Unpublish": "Opozovi objavu",
  "Unrecoverable error - this browser does not permit file uploading of any kind due to serious bugs in iOS8 Safari. Please use iOS8 Chrome until Apple fixes these issues.": "Došlo je do nepopravlјive greške – ovaj pretraživač ne dozvolјava otpremanje datoteka bilo koje vrste zbog ozbilјnih grešaka u programu iOS8 Safari. Koristite iOS8 Chrome dok Apple ne reši te probleme.",
  "Unschedule": "Otkaži zakazano",
  "Unsupported ISO-8601 date format": "Nepodržani ISO 8601 format datuma",
  "Unsupported ISO-8601 date-time format": "Nepodržani ISO-8601 format datuma i vremena",
  "Up-to-date": "Ažurno",
  "Update frequency": "Frekvencija ažuriranja",
  "Upload an image": "Objavlјivanje slike",
  "Upload error on {name}": "Greška pri otpremanju za {name}",
  "Upload your organization logo": "Otpremite logotip svoje organizacije",
  "Upload your post image": "Otpremite sliku objave",
  "Upload your reuse thumbnail": "Otpremite sličicu primera upotrebe",
  "User": "Korisnik",
  "User Image": "Slika korisnika",
  "User has been updated.": "Korisnik je ažuriran.",
  "Users": "Korisnici",
  "Validate": "Potvrdite",
  "Validation": "Validacija",
  "Verification": "Potvrda",
  "Views": "Prikazi",
  "Website": "Veb-sajt",
  "Why not add some more?": "Zašto ne biste dodali još?",
  "Why not improve it?": "Zašto ga ne biste pobolјšali?",
  "Write your post": "Napiši objavu",
  "Write your topic": "Napiši temu",
  "Writing": "Objava",
  "You are about to delete the profile of the user {fullname}.": "Brisanje profila korisnika {fullname}.",
  "You are about to delete this dataset": "Nameravate da izbrišete ovaj skup podataka",
  "You are about to delete this discussion": "Nameravate da izbrišete ovu diskusiju",
  "You are about to delete this harvest source": "Nameravate da izbrišete ovaj izvor preuzimanja",
  "You are about to delete this organization": "Nameravate da izbrišete ovu organizaciju",
  "You are about to delete this post": "Obrisaćete ovu objavu",
  "You are about to delete this resource": "Nameravate da izbrišete ovaj resurs",
  "You are about to delete this reuse": "Nameravate da izbrišete ovaj primer upotrebe",
  "You are about to delete this topic": "Obrisaćete ovu temu",
  "You are about to delete your profile.": "Brisanje vašeg profila",
  "You are about to publish this post": "Nameravate ovo da objavite",
  "You are about to restore this dataset": "Nameravate da poništite brisanje ovog skupa podataka",
  "You are about to restore this organization": "Nameravate da poništite brisanje ove organizacije",
  "You are about to restore this reuse": "Nameravate da poništite brisanje ovog primera upotrebe",
  "You are about to unpublish this post": "Nameravate da opozovete objavu",
  "You are about to unschedule this harvest source": "Otkazivanje zakazanog žetelaca",
  "You are about to validate (or not) this harvest source.": "Nameravate da potvrdite (ili ne potvrdite) ovaj izvor preuzimanja.",
  "You are currently involved in all discussions!": "Trenutno ste uklјučeni u sve diskusije!",
  "You are going to send a transfer request for": "Nameravate da pošalјete zahtev za prenos za",
  "You are not a member of any organization.": "Vi niste član niti jedne organizacije",
  "You are not allowed to perform this operation": "Nemate potrebne dozvole da izvršite ovu operaciju",
  "You can also link to an existing remote file or URL by clicking here.": "Takođe možete povezati eksterni fajl ili URL, kliknite ovde.",
  "You can now either publish a dataset or a reuse.": "Sada možete da objavite skup podataka ili primer upotrebe.",
  "You currently have no frequency set for that dataset, is that pertinent?": "Trenutno nemate podešenu frekvenciju za taj skup podataka. Da li je to relevantno?",
  "You currently have some open formats!": "Trenutno imate neke podatke u otvorenom formatu!",
  "You currently set your frequency to {frequency}.": "Trenutno ste postavili frekvenciju na {frequency}.",
  "You don't have generated an API KEY yet.": "Još uvek niste generisali API klјuč.",
  "You have some untreated discussion threads. Why do not you give it a look below?": "Imate neke nerešene niti diskusije. Zašto ih ne biste pogledali u nastavku?",
  "You need to be logged in to comment.": "Morate biti prijavlјeni da biste komentarisali.",
  "You need to be logged in to follow.": "Morate biti prijavlјeni da biste pratili.",
  "You need to be logged in to start a discussion.": "Morate biti ulogovani da bi startovali diskusiju.",
  "You only have closed formats or no format defined. Can you fill the format info or export some resources in an open format?": "Trenutno imate samo podatke u zatvorenom ili nedefinisanom formatu. Možete li da popunite informacije o formatu ili da objavite neke resurse u otvorenom formatu?",
  "You'll be notified on approval (or refusal)": "Bićete obavešteni o odobrenju (ili odbijanju)",
  "You're about to start a new discussion thread. Make sure that a thread about the same topic doesn't exist yet just above.": "Kreirate novu nit na diskusiji. Proverite da li slična nit već postoji.",
  "Your community resource has been created": "Resurs zajednice je napravlјen",
  "Your dataset has been created": "Skup podataka je napravlјen",
  "Your dataset has been updated.": "Vaš skup podataka je ažuriran.",
  "Your description has currently {description_length} caracters.": "Vaš opis trenutno ima {description_length} znak(ov)a.",
  "Your harvester has been created": "Harvester je napravlјen",
  "Your harvester is now pending for team review.": "Harvester sada čeka na pregled tima.",
  "Your harvester is ready": "Harvester je spreman",
  "Your organization has been created": "Vaša organizacija je napravlјena",
  "Your organization has been updated.": "Vaša organizacija je ažurirana.",
  "Your post has been updated.": "Vaša objava je ažurirana.",
  "Your profile has been updated.": "Vaš profil je ažuriran",
  "Your resource has been added.": "Vaš resurs je dodat.",
  "Your resource has been deleted.": "Vaš resurs je obrisan.",
  "Your resource has been updated.": "Vaš resurs je ažuriran.",
  "Your reuse has been created": "Primer upotrebe je napravlјen",
  "Your reuse has been updated.": "Vaš primer upotrebe je ažuriran.",
  "Your topic has been updated.": "Vaša tema je ažurirana.",
  "and": "i",
  "by": "od",
  "change": "promena",
  "closed discussion": "zatvorena diskusija",
  "emphasized text": "naglašeni tekst",
  "enter image description here": "ovde unesite opis slike",
  "enter image title here": "ovde unesite naslov slike",
  "enter link description here": "ovde unesite opis veze",
  "followed organization": "prati organizaciju",
  "heading text": "tekst naslova",
  "last response": "poslednji odgovor",
  "list text here": "tekst liste ovde",
  "messages": "poruke",
  "on": "na",
  "or": "ili",
  "sort by": "",
  "strong text": "jak tekst",
  "to": "do",
  "topic creation": "kreiranje teme",
  "valid-creditcard": "valid-creditcard",
  "valid-date": "valid-date",
  "valid-date-iso": "valid-date-iso",
  "valid-digits": "valid-digits",
  "valid-email": "valid-email",
  "valid-equal-to": "valid-equal-to",
  "valid-max": "valid-max",
  "valid-maxlength": "valid-maxlength",
  "valid-min": "valid-min",
  "valid-minlength": "valid-minlength",
  "valid-number": "valid-number",
  "valid-range": "valid-range",
  "valid-range-length": "valid-range-length",
  "valid-remote": "valid-remote",
  "valid-required": "valid-required",
  "valid-url": "valid-url",
  "{count} New Requests": "Novi zahtevi: {count}",
  "{file} has an invalid extension. Valid extension(s): {extensions}.": "{file} ima nevažeću oznaku tipa datoteke. Važeće oznake tipa datoteke: {extensions}.",
  "{file} is empty, please select files again without it.": "Datoteka {file} je prazna. Ponovo izaberite datoteke bez nje.",
  "{file} is too large, maximum file size is {sizeLimit}.": "Datoteka {file} je prevelika; maksimalna veličina datoteke je {sizeLimit}.",
  "{file} is too small, minimum file size is {minSizeLimit}.": "Datoteka {file} je premala; minimalna veličina datoteke je {minSizeLimit}.",
  "{name} has been scheduled on {schedule}": "{name} je zakazano za {schedule}",
  "{name} has been unscheduled": "{name} otkazan",
  "{start} to {end}": "od {start} do {end}",
  "{user} is not a member of this organization anymore": "{user} više nije član ove organizacije",
  "{user} is now {role} of this organization": "{user} je sada {role} u ovoj organizaciji",
  "An error occurred while featuring this subject.": "",
  "Preview of resource X": "Pregled u resursa X",
  "Edit resource": "Izmenite resurs",
  "downloads": "preuzimanja",
  "Nameless resource": "Resurs bez imena",
  "Available": "Dostupno",
  "Unavailable": "Nesostupno",
  "See more details": "Vidite još detalјa",
  "Copy permalink to clipboard": "Prekopirajte permalink u klipbord",
  "Resource link": "Veza resursa",
  "Download resource": "Preuzmite resurs",
  "Permalink": "Permalink",
  "MIME Type": "MIME tip",
  "An error occurred while fetching resources": "Došlo je do greške kod preuzimanja resursa",
  "See schema": "Vidite šemu",
  "Associated schema": "Pridružena šema",
  "This resource is associated to the schema ": "Ovaj resurs je pridružen šemi ",
  "this means that the producer reports that it adheres to the specification.": "ovo znači da izvor izjavlјuje da se pridržava specifikacije.",
  "Documentation": "Dokumentacija",
  "You can view the schema documentation, discover some context and recommendations for data producers.": "Možete videti dokumentaciju šeme, otkriti kontekst i preporuke za izvore.",
  "Read documentation": "Pročitajte dokumentaciju",
  "Resource validation based on a schema is a way to verify that the resource complies to the schema it is supposed to abide by. In case of errors, a validation report shows the errors found: wrongly named columns, non conform values, etc.": "Validacija resursa zasnovana na šemi je način da se proveri da li je resurs usklađen sa šemom koju bi trebalo da poštuje. U slučaju grešaka, izveštaj o validaciji pokazuje pronađene greške: pogrešno imenovane kolone, neusaglašene vrednosti, itd.",
  "data.gouv.fr allows you to validate your files based on a schema and correct the possible errors.": "ovaj portal vam dozvolјava validaciju vaših fajlova na osnovu šeme i ispravku eventualnih grešaka.",
  "Validate resource": "Validacija resursa",
  "Others resources": "Ostali resursi",
  "You can specify that a resource complies to a schema on your producer dashboard. Other resources complying with the schema are available on the platform.": "Možete navesti da je resurs usklađen sa šemom na kontrolnoj tabli vašeg izvora. Drugi resursi koji su u skladu sa šemom dostupni su na platformi.",
  "See dataset linked to this schema": "Vidite skup podataka povezan sa šemom",
  "About schemas": "O šemama",
  "Data schemas allow to describe data models : what are the fields, how is data represented, what are the possible values. Discover how schemas improve data quality and use cases on ": "Šeme podataka omogućavaju opisivanje modela podataka: koja su polјa, kako su podaci predstavlјeni, koje su moguće vrednosti. Otkrijte kako šeme pobolјšavaju kvalitet podataka i slučajeve upotrebe nad ",
  "resources": "resursa",
  "reuses": "upotreba",
  "favourites": "podržavanja",
  "Admin": "Admin",
  "Reply to the discussion": "Odgovorite na diskusiju",
  "Reply as": "Odgovorite kao",
  "Submit": "Podnesite",
  "Error sending response": "Greška kod slanja odgovora",
  "Discussion closed": "Diskusija završena",
  "Copy permalink": "Kopirajte permalink",
  "Reply": "Odgovor",
  "The discussion was closed by": "Diskusija je zatvorena od strane",
  "New discussion": "Nova diskusija",
  "Message": "Poruka",
  "Sort discussions by": "Rasporedi diskusije po",
  "You are seeing a specific discussion about this dataset": "Vidite posebne diskusije o ovom skupu podataka",
  "See all discussions about this dataset": "Vidite sve diskusije o ovom skupu podataka",
  "Discussion creation": "Kreiranje diskusije",
  "Last reply": "Poslednji odgovor",
  "An error occurred while fetching discussions": "Došlo je do greške kod dohvatanja diskusija",
  "An error occurred while fetching the discussion ": "Došlo je do greške kod dohvatanja diskusije",
  "An error occurred while creating the discussion ": "Došlo je do greške kod kreiranja diskusije",
  "Ask to join the organization as a producer": "Pridruži se kao izvor",
  "You can add some details here for your membership request": "Možete dodati detalјe ovde za vaš zahtev za članstvo",
  "A request has been sent to the administrators": "Zahtev je poslat administratorima",
  "Error while requesting membership": "Greška kod zahteva za članstvo",
  "Page": "Strana",
  "There are no results for your search": "Nema rezultata za vašu pretragu",
  "from": "od",
  "Search...": "Pretraga...",
  "Search for data...": "Pretraga podataka...",
  "Search reuses": "Primeri upotrebe",
  "Search filters": "Filter pretrage",
  "Search an organization...": "Pretraga organizacija...",
  "Search a tag...": "Pretraga tagova...",
  "Licenses": "Licence",
  "Search a license...": "Pretraga licnci...",
  "Formats": "Formati",
  "Search a format...": "Pretraga formata...",
  "Geographic area": "Geografska oblast",
  "Search a geographic area...": "Pretraga geografske oblasti",
  "Territorial granularity": "Teritorijalna granularnost",
  "Search a granularity...": "Pretraga granularnosti...",
  "Reset filters": "Reset filtera",
  "No dataset matching your query": "Nema skupa podataka koji odgovaraju upitu",
  "You can try to reset the filters to expand your search.": "Možete da resetujete filtere radi proširenja pretrage",
  "Error getting search results.": "Greška kod dobijanja rezultata pretrage",
  "Search for data, reuses, contributions...": "Pretraga podataka, primera upotreba, doprinosa... ",
  "Search all datasets": "Pretraga svih skupova podataka",
  "Datasets are collections of data, i.e. structured information, easily readable by a machine.": "Skupovi podataka su struktuirane informacije koje mašine lako čitaju.",
  "See all datasets": "Vidite sve skupove podataka",
  "Search in datasets": "Pretraga u skupovima podataka",
  "Search in reuses": "Pretraga  u primerima upotreba",
  "Reuses refer to the use of data for an other purpose than the one they were produced for.": "Primeri upotreba se odnose na korišćenje podataka u drugačiju svrhu od one za koju su stvoreni.",
  "See the reuses": "Vidite primere upotrebe",
  "No reuse matching your query": "Nema primera upotrebe koji odgovaraju vašem upitu",
  "No results found.": "Nema pronađenih rezultata.",
  "Unfeature this content": "Prekinite istaknutost ovog sadržaja",
  "remove from favorites": "uklonite iz omilјnenih",
  "add to favorites": "dodajte u omilјene",
  "Read less": "Čitajte manje",
  "Read more": "Čitajte više",
  "Created date asc": "Datum kreiranja naviše",
  "Created date desc": "Datum kreiranja",
  "Last modified asc": "Datum poslednje izmene naviše",
  "Last modified desc": "Datum poslednje izmene",
  "Title asc": "Naslov naviše",
  "Title desc": "Naslov naniže",
  "Followers asc": "Pratioci naviše",
  "Followers desc": "Broj pratioca",
  "Reuses asc": "Primeri upotrebe naviše",
  "Reuses desc": "Primeri upotrebe",
  "Download datasets": "Preuzmi podatke",
  "Download resources": "Preuzmi resurse",
  "Documents": "Dokumenta",
  "Documents and instructions": "Dokumenti i uputstva",
  "Law and by laws": "Zakon i podzakonska akta",
  "Instructions": "Uputstva",
  "Добродошли на портал отворених података": "Dobrodošli na portal otvorenih podataka",
  "Sort by": "",
  "Search by sort...": "Raspored prema..."
}